<div data-cy="my-claimed-tasks">
	<app-dashboard-card
		title="Claimed Tasks"
		icon="pi pi-check-square"
	>
		<div
			dashboardCardActions
			class="claimed-tasks-header-actions"
		>
			<p-calendar
				(onSelect)="onDateChange()"
				[(ngModel)]="selectedDate"
				[maxDate]="maxDate"
				class="claimed-tasks-date"
				dateFormat="dd/mm/yy"
				showIcon
			></p-calendar>

			<button
				(click)="goToTaskCalendar()"
				class="p-button-primary p-button-sm claimed-calendar-button"
				icon="pi pi-calendar"
				label="Calendar"
				pButton
			></button>
		</div>

		<!-- ============================================= -->
		<!-- SHOW LESS                                     -->
		<!-- ============================================= -->

		<div
			*ngIf="claimedTasks.length > 0"
			class="claimed-tasks-expand claimed-tasks-expand-top"
		>
			<button
				type="button"
				class="claimed-tasks-expand-link"
				(click)="decreaseTilesInView()"
			>
				Show less
				<i class="pi pi-chevron-up"></i>
			</button>
		</div>

		<!-- ============================================= -->
		<!-- TASKS                                         -->
		<!-- ============================================= -->

		<div class="claimed-tasks-container">
			<div
				*ngIf="isLoading"
				class="no-tasks-message"
			>
				Loading claimed tasks...
			</div>

			<ng-container *ngIf="!isLoading">
				<div
					*ngIf="dataLoaded && claimedTasks.length === 0"
					class="no-tasks-message"
				>
					No tasks available for the selected date range.
				</div>

				<div
					*ngIf="claimedTasks.length > 0"
					data-cy="slider-container"
					class="slider-container"
				>
					<button
						type="button"
						pButton
						icon="pi pi-chevron-left"
						class="slider-button"
						aria-label="Previous claimed tasks"
						(click)="moveLeft()"
					></button>

					<div
						#tileContainer
						class="tile-container"
					>
						<div
							*ngFor="
								let task of claimedTasks.slice(
									visibleStartIndex,
									visibleStartIndex + tilesInView
								)
							"
							class="task-item"
							[ngClass]="{
								'highlighted-task': isSelectedTask(task)
							}"
							(click)="onTaskClick(task)"
						>
							<span class="task-date">
								{{ task.start | DateLocalFormat: false }}
							</span>

							<div
								class="task-status"
								[ngClass]="{
									'bg-danger':
										task.className === 'day-cell-overdue',
									'bg-warning':
										task.className === 'day-cell-normal',
									'bg-success':
										task.className === 'day-cell-complete'
								}"
							>
								<i
									class="pi"
									[ngClass]="{
										'pi-exclamation-circle':
											task.className ===
											'day-cell-overdue',
										'pi-check-circle':
											task.className ===
											'day-cell-complete',
										'pi-cog':
											task.className ===
											'day-cell-normal'
									}"
								></i>
							</div>

							<div class="task-metrics">
								<div
									class="metric-dot workflow-dot-daily"
									title="Daily tasks"
								>
									{{ task.extendedProps.dailyCount }}
								</div>

								<div
									class="metric-dot workflow-dot-non-daily"
									title="Non-daily tasks"
								>
									{{ task.extendedProps.nonDailyCount }}
								</div>

								<div
									*ngIf="userPermissions.forms.read"
									data-cy="task-metric-form-count"
									class="metric-dot form-dot"
									title="Forms"
								>
									{{ task.extendedProps.formCount }}
								</div>
							</div>
						</div>
					</div>

					<button
						type="button"
						pButton
						icon="pi pi-chevron-right"
						class="slider-button"
						aria-label="Next claimed tasks"
						(click)="moveRight()"
					></button>
				</div>
			</ng-container>
		</div>

		<!-- ============================================= -->
		<!-- SHOW MORE                                     -->
		<!-- ============================================= -->

		<div
			*ngIf="claimedTasks.length > 0"
			class="claimed-tasks-expand claimed-tasks-expand-bottom"
		>
			<button
				type="button"
				class="claimed-tasks-expand-link"
				(click)="increaseTilesInView()"
			>
				Show more
				<i class="pi pi-chevron-down"></i>
			</button>
		</div>
	</app-dashboard-card>
</div>
